import { useNavigate } from "react-router-dom"

const Unauthorized = () => {
    const navigate = useNavigate();

    const goBack = () => navigate(-1);

    return (
        <section className="fade-in" style={{ textAlign: "center", maxWidth: "600px" }}>
            <div style={{ fontSize: "4rem", marginBottom: "1rem" }}>🚫</div>
            <h1 style={{
                fontSize: "2.5rem",
                marginBottom: "1rem",
                background: "linear-gradient(135deg, var(--error-red), var(--warning-amber))",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text"
            }}>
                Unauthorized Access
            </h1>
            <p style={{ color: "var(--text-secondary)", marginBottom: "2rem", fontSize: "1.125rem" }}>
                You do not have permission to view the requested page.
            </p>
            <div className="flexGrow">
                <button className="btn-primary" onClick={goBack}>
                    Go Back
                </button>
            </div>
        </section>
    )
}

export default Unauthorized
